import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';

export const Tooltip = ({ ...rest }: TooltipProps) => <MuiTooltip {...rest} />;
